<template>
<div>
  <div class="row justify-content-center">
                      <div class=" col-sm-12 grid-margin stretch-card">

                        <div class="card">
                          <div class="card-tile text-center p-2"><h2 class="">Promotion Bonus</h2></div>
                          <div class="card-body text-center">
                            <p class="text-danger"><b>Note:</b>Please verify and confirm before disbursing money.If you verify that the log is fake,please delete it.</p>
                            <div class="mb-3 row justify-content-center">
                              <div class="col-sm-6 float-right">
                              <input type="text" v-model="message.filterval"  v-on:keyup="filter()" class="form-control" placeholder="Type to start filtering">

                              </div>
                               <div class="col-sm-4 float-right">
                                <!-- <a class="btn btn-success" v-on:click="showModal()">Add Record</a> -->
                               </div>
                            </div>
                            <div class="table-responsive p-0">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr class="text-center">
                      <th class="text-uppercase  text-xxs font-weight-bolder">#</th>
                      <th class="text-uppercase  text-xxs font-weight-bolder  ">Mpesa ID</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Phone</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">System Ref</th>
                      <th class=" text-uppercase  text-xxs font-weight-bolder ">Value</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Mpesa</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Date</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Status</th>
                        <th class=" text-uppercase  text-xxs font-weight-bolder ">Type</th>
                       <th class=" text-uppercase  text-xxs font-weight-bolder ">Action</th>

                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data,index) in pageOfItems" :key="data.id" class="text-center">
                      <td>
                        {{index+1}}
                      </td>
                      <td>
                        {{data.mpesa_ref}}
                      </td>
                      <td >
                        {{data.phone}}
                      </td>
                       <td >
                        {{data.system_ref}}
                      </td>
                      <td >
                       Ksh.{{formatPrice(data.value)}}
                      </td>
                      <td >
                      Ksh. {{formatPrice(data.amount)}}
                      </td>
                      <td >
                       {{formatDate(data.created_at)}}
                      </td>
                      <td  v-if="data.status==='PENDING'">
                       <i class="text-warning">PENDING</i>
                      </td>
                      <td  v-else-if="data.status==='FAILED'">
                       <i class="text-danger">TRANS FAILED</i>
                      </td>
                      <td  v-else>
                       <i class="text-success">DISBURSED</i>
                      </td>
                      <td >
                        {{data.type}}
                      </td>
                      <td  v-if="data.status!=='PAID'">
                        <a v-on:click="getAuthOTP(data.id)" class="ml-5" href="#">Disburse <i class="mdi mdi-reply-all"></i></a>
                         <a v-on:click="Delete(data.id)" class="ml-5 text-danger" href="#">Delete <i class="mdi mdi-delete-forever"></i></a>
                        </td>

                    </tr>

                  </tbody>
                </table>
              </div>
              <div class="row mt-4 justify-content-center">
                    <div class="col-sm-12">
                        <jw-pagination :items="logs"  @changePage="onChangePage" ></jw-pagination>
                    </div>
                </div>

                          </div>
                        </div>




                        </div>
                        </div>

  <div class="modal fade" id="edit" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Send Mpesa Amount</h6>
         <p class="text-center">A four digit verification code  has been sent to your phone.Please enter the code to complete transaction</p>

         <p class="text-center"><b>NOTE:</b>This transaction will award <b>{{message.phone}}</b> Amount of Ksh.<b>{{formatPrice(message.amount)}}</b></p>
         <p class="text-center">Please click Complete to authorise</p>

         <div class="form-group mt-3">
                    <label class="form-label">OTP</label>
                    <input type="text" v-model="message.code" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Account</label>
                    <input type="text" v-model="message.phone" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Amount</label>
                    <input type="text" v-model="message.amount" class="form-control" required>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="pushwithdrawal()">Compelete</button>
      </div>
    </div>
  </div>
</div>

  <div class="modal fade" id="add" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">

      <div class="modal-body">
         <h6 class="text-center">Add transactions record</h6>

         <div class="form-group mt-3">
                    <label class="form-label">Phone</label>
                    <input type="text" v-model="message.phone" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Transaction type</label>
                    <div class="row justify-content-center">
                      <div class="form-check form-check-inline col-sm-6" v-on:click="changeType('airtime')">
  <input class="form-check-input " type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" checked>
  <label class="form-check-label" for="inlineRadio1">Credit</label>
</div>
<div class="form-check form-check-inline col-sm-6" v-on:click="changeType('bonga')">
  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2">
  <label class="form-check-label" for="inlineRadio2">Bonga</label>
</div>
                    </div>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Amount of <b class="text-success">{{message.type}}</b> received</label>
                    <input type="text" v-model="message.value" v-on:keyup="calculatePrice()" class="form-control" required>
                  </div>
                  <div class="form-group mt-3">
                    <label class="form-label">Amount in Mpesa</label>
                    <input type="text" v-model="message.amount" class="form-control" required disabled>
                  </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" v-on:click="addCreditdata()">Save</button>
      </div>
    </div>
  </div>
</div>
</div>
</template>
<script>
    import moment from 'moment'
    export default {
        name: 'App',
        components: {

        },
        data(){
            return {
            logs:[],
             logs2:[],
            message:{type:'airtime',amount:'0.00','value':'0.00'},
            pageOfItems:[],
            discount:{}

            }
        },
        created(){
              this.getCredits();
        },
        methods: {
          changeType(type){
            this.message.type=type;
            this.message.amount='0.00';
            this.message.value='0.00';

          },
          calculatePrice(){
           if(this.message.type==='bonga'){
          this.message.amount=+this.message.value* +this.discount.bonga.rate;
           }else{
            this.message.amount=Math.round((+this.message.value)-((+this.discount.mpesa.rate * +this.message.value)/100));
          }
          },
          showModal(){
         this.$loading(true)
               let uri =`/api/auth/discount`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   $('#add').modal('show');
                   this.discount=response.data;
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
           onChangePage(pageOfItems) {
            this.pageOfItems = pageOfItems;
        },
        addCreditdata(){
        $('#add').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/addCreditdata`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                    this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                    this.message={type:'airtime',amount:'0.00','value':'0.00'};
                  this.getCredits();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
        },
          pushwithdrawal(){
             $('#edit').modal('hide');
             this.$loading(true)
               let uri =`/api/auth/pushwithdrawal/${this.message.id}`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                    this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                  this.getCredits();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },
          Delete(id){
            this.$swal({
  title: 'Are you sure youi want to delete this record?',
  text: "You won't be able to revert this!",
  icon: 'warning',
  showCancelButton: true,
  confirmButtonColor: '#3085d6',
  cancelButtonColor: '#d33',
  confirmButtonText: 'Yes, delete it!'
}).then((result) => {
  if (result.isConfirmed) {
    this.$loading(true)
               let uri =`/api/auth/deleteCredit/${id}`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                     this.$toast.open({message: response.data.message, type: 'success', position: 'top'});
                    this.getCredits();
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
  }
})

          },
          getAuthOTP(id){
             this.$loading(true)
               let uri =`/api/auth/getAuthOTPMpesa/${id}`;
                this.axios.post(uri,this.message, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {
                    this.$loading(false)
                   if(response.data.status){
                    this.message=response.data.logs
                   $('#edit').modal('show');
                   }else{
                   this.$toast.open({message: response.data.message, type: 'error', position: 'top'});
                   }
                }).catch(error => {
                   this.$loading(false)
                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
          },

            getCredits(){

                let uri =`/api/auth/getBonus`;
                this.axios.get(uri, { headers: { Authorization: 'Bearer '+localStorage.getItem('token')}}).then((response) => {

                 this.logs=response.data;
                 this.logs2=response.data;
                }).catch(error => {

                    if (error.response.status === 401) {
                    this.$router.push({name: 'index'});
                    this.$toast.open({message: 'Please sign in!', type: 'error', position: 'top'});
                }else{
                    this.$toast.open({message: 'Something went wrong!.', type: 'error', position: 'top'});
                }

                });
            },

           filter(){
            let filterval=this.message.filterval;
            if(filterval==='' || filterval===null){
                this.logs=this.logs2;
            }else{
                let ads =  this.logs2.filter(function(product) {
                    return   product.phone.toLowerCase().includes(filterval.toLowerCase())
                });
                this.logs=ads;
            }
        },
            formatPrice(value) {
                let val = (value/1).toFixed(2).replace('.', '.');
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            },
            formatDate(date){
                return moment(String(date)).format('MM/DD/YYYY HH:mm')
            }

        },
    }

</script>
